<template>
  <svg class="RadialProgress" ref="svg"></svg>
</template>

<script>
  import * as d3 from 'd3';
  import { colour, interpolateColour } from '@/legacy/lib/util';
  import { rgba } from '@/legacy/lib/template';

  export default {
    props: {
      fill: {
        type: Number,
        default: 80
      },

      radius: {
        type: Number,
        default: 20
      },

      thickness: {
        type: Number,
        default: 3
      },

      value: {
        type: [ Number, String ],
        default: null
      }
    },

    mounted: function () {
      let radius    = this.radius;
      let thickness = this.thickness;
      let thetaI    = 0;
      let thetaF    = Math.PI * 2;

      let count     = this.fill;
      let progress  = 0;
      let textValue = this.value;

      if (textValue === null) {
        textValue = d3.format ('.0%') (this.fill / 100);
      }

      let circle = d3
        .arc ()
        .startAngle (thetaI)
        .innerRadius (radius)
        .outerRadius (radius - thickness);

      let svg = d3
        .select (this.$refs.svg)
        .attr ('width',  this.radius * 2)
        .attr ('height', this.radius * 2);

      let g = svg
        .append ('g')
        .attr ('transform', `translate(${radius}, ${radius})`);

      let track = g
        .append ('g')
        .attr ('class', 'radial-progress');

      track.append ('path')
        .attr ('class', 'radial-progress__background')
        .attr ('fill', rgba('--white', 0.2))
        .attr ('stroke', rgba('--white', 0.2))
        .attr ('stroke-width', '1px')
        .attr ('d', circle.endAngle (thetaF));

      let value = track
        .append ('path')
        .attr ('class', 'radial-progress__value')
        .attr ('fill', interpolateColour (this.fill))
        .attr ('stroke', interpolateColour (this.fill))
        .attr ('stroke-width', '1px');

      let text = track
        .append ('text')
        .attr ('class', 'radial-progress__text')
        .attr ('fill', rgba ('--sand'))
        .attr ('text-anchor', 'middle')
        .attr ('dy', '.25rem');

      (function iterate () {
        value.attr ('d', circle.endAngle (thetaF * progress));
        text.text (textValue);

        if (count > 0) {
          count--;
          progress += 0.01;
          setTimeout (iterate, 10);
        }
      }) ();
    }
  }
</script>

<style lang="scss">
  .RadialProgress {
    text {
      font-size: 10px;
    }
  }
</style>